import { render, staticRenderFns } from "./JianKang_todo.vue?vue&type=template&id=e037f014&scoped=true"
import script from "./JianKang_todo.vue?vue&type=script&lang=js"
export * from "./JianKang_todo.vue?vue&type=script&lang=js"
import style0 from "./JianKang_todo.vue?vue&type=style&index=0&id=e037f014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e037f014",
  null
  
)

export default component.exports